// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"01a8ce8e","453":"7101d032","732":"cfc664dc","977":"963e46e9"}[chunkId] + ".chunk.js";
};